<template>
        <div ref="risknation" class="pbr-index-chart">
<Empty></Empty>
                        </div>
</template>

<script>
import * as echarts from 'echarts'
import {chartColors} from '../../../analysis/constant'
import Mixin from '../mixin'
import ResizeObserver from 'resize-observer-polyfill'
export default {
  name: 'pbrChartRiskNation',
  mixins: [Mixin],
  inject: ['chartDatas'],
  props: {
    data: {
      type: Array,
      require: true,
      default: () => []
    },
    height: { type: Number }
  },
  data () {
    return {
      risknationDom: null,
      risknationChart: null,
      optionRisknation: null,
      isResize: false,
    }
  },
  computed: {
    chartData () {
      const riskChartData = this.chartDatas.riskChartData()
      // return riskChartData.riskNationChart || [{}]
      if (riskChartData.hasOwnProperty('riskNationChart') && riskChartData.riskNationChart.length > 0) {
        return riskChartData.riskNationChart
      }
      return [{name: '', num: 0, percent: 0}]
    }
  },
  methods: {
    drawChart (theme = 'light') {
      let self = this
      if(!this.$refs.risknation){
        return
      }
      if (this.risknationChart) {
        this.risknationChart.dispose()
      }
      let countContrastDom = this.$refs.risknation
      this.risknationChart = echarts.init(countContrastDom, theme, {devicePixelRatio: 2.5})
      this.risknationChart.setOption(this.optionRisknation)
      this.risknationChart.on('click', function (param) {
        self.dispatch('pbrIndex', 'filterData', {module: 'fx', condition: {type: 'country', title: param.data.name, id: param.data.id}})
      })

      let that = this;
      let countContrastObserver = new ResizeObserver((entries) => {
        if (that.isResize) {
          that.risknationChart.resize()
          if (entries && entries.length > 0 && entries[0].borderBoxSize[0].blockSize > 0) {
            that.isResize = false;
          }
        }
      })
      countContrastObserver.observe(countContrastDom);
    },
    generateOptions () {
      this.optionRisknation = {
        color: chartColors,
        title: {
          show: this.showTitle,
          text: this.$t('charts.home.risk.countriesDistribution'),
          left: 'center',
          top:0
        },
        tooltip:{
          confine:true,
          className: 'pbr-echarts-formatter-box',
          textStyle:{
            color:"inherit"
          },
          backgroundColor: "#fff",
          shadowBlur: 10,
          shadowColor: "rgba(0, 0, 0, .2)",
          shadowOffsetX: 1,
          shadowOffsetY: 2,
          borderRadius: 4,
          borderWidth: 1
        },
        dataset: {
          dimensions: ['name', 'num', 'percent', 'id'],
          source: this.chartData
        },
        grid: {
          bottom:0,
          top: this.showTitle ? 30 : 0,
          left: 0,
          containLabel: true
        },
        xAxis: {},
        yAxis: {
          type: 'category',
          axisTick: {
            show: false
          },
          inverse: true,
        },
        series:
          {
            type: 'bar',
            colorBy:'data',
            name: this.$t('charts.home.risk.countriesDistribution'),
            label: {
              show: true
            },
            emphasis: {
              itemStyle: {
                fontSize: 18,
                opacity: 1
              }
            }
          }

      }
    }
    // generateOptions () {
    //   this.optionRisknation = {
    //     title: {
    //       show: this.showTitle,
    //       text: '风险国家',
    //       left: 'center'
    //     },
    //     tooltip: {
    //       trigger: 'item'
    //     },
    //     legend: {
    //       orient: 'vertical',
    //       right: 10,
    //       top: 'top',
    //       itemHeight: 8,
    //       itemWidth: 15,
    //       textStyle: {
    //         fontSize: 10,
    //         lineHeight: 10
    //       },
    //       align: 'right',
    //       itemGap: 3
    //     },
    //     dataset: {
    //       dimensions: ['name', 'num', 'id'],
    //       source: this.chartData
    //     },
    //     grid: {
    //       bottom: 0,
    //       left: 0,
    //       right: 0,
    //       top: this.showTitle ? 40 : 0,
    //       containLabel: true
    //     },
    //     series: [
    //       {
    //         name: '风险行业',
    //         type: 'pie',
    //         radius: '70%',
    //         center: [this.showTitle ? '50%' : '35%', '50%', '50%'],
    //         label: {
    //           fontSize: 10,
    //           distanceToLabelLine: 1,
    //           edgeDistance: 0
    //         },
    //         labelLine: {
    //           shouAbove: true,
    //           length: 5,
    //           length2: 5
    //         },
    //         emphasis: {
    //           itemStyle: {
    //             shadowBlur: 10,
    //             shadowOffsetX: 0,
    //             shadowColor: 'rgba(0, 0, 0, 0.5)'
    //           }
    //         }
    //       }
    //     ]
    //   }
    // }
    ,
    resize () {
      this.isResize = true
      this.risknationChart.resize()
    }
  },
  mounted () {
    this.generateOptions()
    this.drawChart(this.theme)
  },
  watch: {
    '$store.state.brpaModule.theme': {
      handler: function (val) {
        this.generateOptions()
        this.drawChart(val || 'white')
      },
      immediate:true
    },
    chartData: {
      handler (newValue, oldValue) {
        if (newValue.length === 0) {
          if (this.risknationChart) {
            this.risknationChart.dispose()
          }
        } else {
          this.generateOptions()
          this.drawChart(this.theme)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
